export const environment = {
  production: true,
  dev: false,
  theme: 'theme',
  features: {
    // console or tuna or merchant
    console: [{
      key: 'dashboard',
      versions: ['v1'],
      current_version: 'v1',
      enabled: true,
      can_add: false,
      is_menu: true,
      desc: 'features.dashboard',
      subfeatures: [],
      configs: {
        icon: 'icon_dashboard',
        title: 'menu.dashboard',
        url: 'dashboard',
      },
      roles: [
        'admin',
        'viewer',
        'it-specialist',
        'finance-specialist',
        'finance-analyst',
      ],
    },
    {
      key: 'transactions',
      versions: ['v1'],
      current_version: 'v1',
      enabled: true,
      desc: 'features.transactions',
      can_add: false,
      is_menu: true,
      subfeatures: [
        {
          key: 'transactions,download',
          versions: ['v1'],
          current_version: 'v1',
          enabled: true,
          desc: 'features.download',
          subfeatures: [],
          configs: {},
          roles: ['admin', 'viewer', 'finance-specialist', 'finance-analyst', 'sales', 'support-merchant'],
        },
        {
          key: "transactions,download_payment_methods",
          versions: ["v1"],
          current_version: "v1",
          can_add: true,
          enabled: false,
          desc: 'features.downloadPaymentMethods',
          subfeatures: [],
          configs: {},
          roles: ['admin', 'viewer', 'finance-specialist', 'finance-analyst']
        },
        {
          key: 'transactions,cancel',
          versions: ['v1'],
          current_version: 'v1',
          desc: 'features.cancel',
          enabled: true,
          subfeatures: [],
          configs: {},
          roles: ['admin', 'finance-specialist', 'finance-analyst'],
        },
        {
          key: 'transactions,details',
          versions: ['v1'],
          current_version: 'v1',
          desc: 'features.details',
          enabled: true,
          subfeatures: [],
          configs: {},
          roles: [
            'admin',
            'viewer',
            'owner',
            'it-specialist',
            'finance-specialist',
            'finance-analyst',
            'sales',
            'support-merchant'
          ],
        },
      ],
      configs: {
        icon: 'icon_transactions',
        title: 'menu.transactions',
        url: 'transactions',
      },
      roles: [
        'admin',
        'viewer',
        'sales',
        'it-specialist',
        'finance-specialist',
        'finance-analyst',
        'support-merchant'
      ],
    },
    {
      key: "payout",
      versions: ["v1"],
      current_version: "v1",
      can_add: true,
      add_all: true,
      enabled: false,
      is_menu: true,
      desc: 'features.payout',
      subfeatures: [],
      configs: {
        icon: "icon_event_available",
        title: "menu.transfer",
        url: "payout"
      },
      roles: ['admin', 'viewer', 'finance-specialist', 'finance-analyst']
    },
    {
      key: 'link',
      versions: ['v1', 'v2'],
      current_version: 'v1',
      can_add: true,
      enabled: false,
      is_menu: true,
      desc: 'features.link',
      subfeatures: [],
      configs: {
        icon: 'icon_link',
        title: 'menu.link',
        url: 'payment-links',
      },
      roles: [
        'admin',
        'sales',
        'it-specialist',
        'finance-specialist',
        'finance-analyst',
        'support-merchant'
      ],
    },
    {
      key: 'services',
      versions: ['v1'],
      current_version: 'v1',
      enabled: true,
      desc: 'features.services',
      subfeatures: [],
      can_add: false,
      is_menu: true,
      configs: {
        icon: 'icon_services',
        title: 'menu.services',
        url: 'services',
      },
      roles: [
        'admin',
        'viewer',
        'it-specialist',
        'finance-specialist',
        'finance-analyst',
      ],
    },
    {
      key: "connections", // adicionado -dev para testes em prod/dev
      versions: ["v1"],
      current_version: "v1",
      desc: 'features.connections',
      subfeatures: [],
      enabled: false,
      can_add: true,
      add_all: true,
      is_menu: true,
      configs: {
        icon: "icon_connections",
        title: "menu.connections",
        url: "connections" // adicionado -dev para testes em prod/dev
      },
      roles: ['admin', 'viewer', 'it-specialist', 'finance-specialist', 'finance-analyst']
    },
    {
      key: "authorizations",
      versions: ["v1"],
      current_version: "v1",
      desc: 'features.authorizations',
      subfeatures: [],
      enabled: true,
      can_add: false,
      add_all: true,
      is_menu: false, // Desativado no menu para testes em prod/dev
      configs: {
        icon: "icon_authorizations",
        title: "menu.authorizations",
        new: "menu.new",
        url: "authorizations"
      },
      roles: ['admin']
    },
    {
      key: "snapshot",
      versions: ["v1"],
      current_version: "v1",
      can_add: false,
      add_all: false,
      enabled: true,
      is_menu: true,
      desc: 'features.snapshot',
      subfeatures: [
        {
          key: "snapshot,create",
          versions: ["v1"],
          current_version: "v1",
          can_add: true,
          enabled: false,
          desc: 'features.snapshotEditflows.create',
          roles: ['admin']
        },
        {
          key: "snapshot,edit",
          versions: ["v1"],
          current_version: "v1",
          can_add: true,
          enabled: false,
          desc: 'features.snapshotEditflows.edit',
          roles: ['admin']
        },
        {
          key: "snapshot,publish",
          versions: ["v1"],
          current_version: "v1",
          can_add: true,
          enabled: false,
          desc: 'features.snapshotEditflows.publish',
          roles: ['admin']
        }
      ],
      configs: {
        icon: "icon_flows",
        title: "menu.flows",
        url: "snapshot"
      },
      roles: ['admin', 'viewer', 'it-specialist', 'finance-specialist', 'finance-analyst']
    },
    {
      key: "merchants",
      versions: ["v1"],
      current_version: "v1",
      can_add: true,
      add_all: true,
      enabled: false,
      is_menu: true,
      desc: 'features.merchants',
      subfeatures: [
        {
          key: "merchants,payout",
          versions: ["v1"],
          current_version: "v1",
          can_add: false,
          enabled: true,
          desc: 'features.payout',
          subfeatures: [],
          configs: {
            title: "menu.merchants.payout",
            url: "merchants/payout"
          },
          roles: ['admin', 'viewer', 'it-specialist', 'finance-specialist', 'finance-analyst', 'support-merchant']
        },
        {
          key: "merchants,company",
          versions: ["v1"],
          current_version: "v1",
          can_add: false,
          enabled: true,
          desc: 'features.company',
          subfeatures: [],
          configs: {
            title: "menu.user.company",
            url: "merchants/:external_id/account"
          },
          roles: ['admin', 'viewer', 'it-specialist', 'finance-specialist', 'finance-analyst', 'support-merchant']
        },
        {
          key: "merchants,services",
          versions: ["v1"],
          current_version: "v1",
          can_add: false,
          enabled: true,
          desc: 'features.services',
          subfeatures: [],
          configs: {
            title: "menu.services",
            url: "merchants/:external_id/services"
          },
          roles: ['admin', 'viewer', 'it-specialist', 'finance-specialist', 'finance-analyst', 'support-merchant']
        },
        {
          key: "merchants,users",
          versions: ["v1"],
          current_version: "v1",
          can_add: false,
          enabled: true,
          desc: 'features.users',
          subfeatures: [],
          configs: {
            icon: "icon_settings",
            title: "menu.user.users",
            url: "merchants/:external_id/users"
          },
          roles: ['admin', 'viewer', 'it-specialist', 'finance-specialist', 'finance-analyst', 'support-merchant']
        },
      ],
      configs: {
        icon: "icon_merchants",
        title: "menu.merchants",
        url: "merchants"
      },
      roles: ['admin', 'viewer', 'it-specialist', 'finance-specialist', 'finance-analyst', 'support-merchant']
    },
    {
      key: 'create_account',
      versions: ['v1'],
      current_version: 'v1',
      enabled: true,
      can_add: false,
      is_menu: false,
      desc: 'features.merchant',
      subfeatures: [],
      configs: {},
      roles: ['admin'],
    },
    {
      key: 'settings',
      versions: ['v1'],
      current_version: 'v1',
      enabled: true,
      can_add: false,
      is_menu: true,
      desc: 'features.settings',
      subfeatures: [
        {
          key: 'profile',
          versions: ['v1'],
          current_version: 'v1',
          enabled: true,
          desc: 'features.profile',
          subfeatures: [],
          configs: {
            title: 'menu.user.userSettings',
            url: 'settings/profile',
          },
          roles: [
            'admin',
            'viewer',
            'sales',
            'owner',
            'it-specialist',
            'finance-specialist',
            'finance-analyst',
            'support-merchant'
          ],
        },
        {
          key: 'users',
          versions: ['v1'],
          current_version: 'v1',
          enabled: true,
          desc: 'features.users',
          subfeatures: [],
          configs: {
            title: 'menu.user.users',
            url: 'settings/users',
          },
          roles: ['admin'],
        },
        {
          key: 'company',
          versions: ['v1'],
          current_version: 'v1',
          enabled: true,
          desc: 'features.company',
          subfeatures: [],
          configs: {
            title: 'menu.user.companySettings',
            url: 'settings/company',
          },
          roles: ['admin'],
        },
        {
          key: 'developer',
          versions: ['v1'],
          current_version: 'v1',
          enabled: true,
          desc: 'features.developer',
          subfeatures: [],
          configs: {
            title: 'menu.user.developer',
            url: 'settings/developer',
          },
          roles: ['admin', 'it-specialist'],
        },
        {
          key: 'webhooks',
          versions: ['v1'],
          current_version: 'v1',
          enabled: true,
          can_add: false,
          is_menu: true,
          desc: 'features.settings',
          subfeatures: [],
          configs: {
            icon: 'icon_settings',
            title: 'menu.user.webhooks',
            url: "settings/webhooks",
          },
          roles: ['admin', 'it-specialist'],
        },
        {
          key: "reports",
          versions: ["v1"],
          current_version: "v1",
          enabled: true,
          desc: 'features.reports',
          subfeatures: [],
          configs: {
            icon: "icon_settings",
            title: "menu.user.reports",
            url: "settings/reports"
          },
          roles: [
            'admin',
            'viewer',
            'sales',
            'owner',
            'it-specialist',
            'finance-specialist',
            'finance-analyst',
            'support-merchant'
          ],
        },
        {
          key: "help",
          versions: ["v1"],
          current_version: "v1",
          enabled: true,
          desc: 'features.help',
          subfeatures: [],
          configs: {
            icon: "icon_settings",
            title: "menu.user.help",
            url: "settings/help"
          },
          roles:
            ['admin',
              'sales',
              'it-specialist',
              'finance-specialist',
              'finance-analyst',
              'support-merchant'
            ]
        },
        {
          key: "settings,letter",
          versions: ["v1"],
          current_version: "v1",
          can_add: true,
          enabled: false,
          desc: 'features.letter',
          subfeatures: [],
          configs: {
            icon: "icon_settings",
            title: "menu.user.letter",
            url: "settings/letter"
          },
          roles:
            ['admin',
              'sales',
              'it-specialist',
              'finance-specialist',
              'finance-analyst',
              'support-merchant'
            ]
        }
      ],
      configs: {
        icon: 'icon_settings',
        title: 'menu.settings',
        url: 'settings',
      },
      roles: [
        'admin',
        'viewer',
        'sales',
        'owner',
        'it-specialist',
        'finance-specialist',
        'finance-analyst',
        'support-merchant'
      ],
    },
    ],
    merchant: [
      {
        key: 'transactions',
        versions: ['v1'],
        current_version: 'v1',
        enabled: true,
        desc: 'features.transactions',
        can_add: false,
        is_menu: true,
        subfeatures: [
          {
            key: 'transactions,download',
            versions: ['v1'],
            current_version: 'v1',
            enabled: true,
            desc: 'features.download',
            subfeatures: [],
            configs: {},
            roles: [
              'owner',
              'admin',
              'merchant-admin',
              'merchant-owner',
            ],
          },
          {
            key: 'transactions,cancel',
            versions: ['v1'],
            current_version: 'v1',
            desc: 'features.cancel',
            enabled: true,
            subfeatures: [],
            configs: {},
            roles: [
              'owner',
              'admin',
              'finance-specialist',
              'merchant-admin',
              'merchant-finance-specialist',
              'merchant-owner'
            ],
          },
          {
            key: 'transactions,details',
            versions: ['v1'],
            current_version: 'v1',
            desc: 'features.details',
            enabled: true,
            subfeatures: [],
            configs: {},
            roles: [
              'admin',
              'viewer',
              'owner',
              'finance-specialist',
              'merchant-admin',
              'merchant-viewer',
              'merchant-owner',
              'merchant-finance-specialist',
            ],
          },
        ],
        configs: {
          icon: 'icon_transactions',
          title: 'menu.transactions',
          url: 'transactions',
        },
        roles: [
          'admin',
          'viewer',
          'owner',
          'finance-analyst',
          'finance-specialist',
          'merchant-finance-analyst',
          'merchant-viewer',
          'merchant-admin',
          'merchant-owner',
          'merchant-finance-analyst',
          'merchant-finance-specialist'
        ],
      },
      {
        key: 'payout',
        versions: ['v1'],
        current_version: 'v1',
        enabled: true,
        can_add: false,
        is_menu: true,
        desc: 'features.merchants',
        subfeatures: [],
        configs: {
          icon: 'icon_event_available',
          title: 'menu.transfer',
          url: 'payout',
        },
        roles: [
          'owner',
          'admin',
          'viewer',
          'finance-specialist',
          'merchant-admin',
          'merchant-viewer',
          'merchant-finance-specialist',
          'merchant-owner'
        ],
      },

      {
        key: 'settings',
        versions: ['v1'],
        current_version: 'v1',
        enabled: true,
        can_add: false,
        is_menu: true,
        desc: 'features.settings',
        subfeatures: [
          {
            key: 'profile',
            versions: ['v1'],
            current_version: 'v1',
            enabled: true,
            desc: 'features.profile',
            subfeatures: [],
            configs: {
              title: 'menu.user.userSettings',
              url: 'settings/profile',
            },
            roles: [
              'admin',
              'viewer',
              'owner',
              'finance-analyst',
              'finance-specialist',
              'merchant-finance-analyst',
              'merchant-viewer',
              'merchant-admin',
              'merchant-owner',
              'merchant-finance-analyst',
              'merchant-finance-specialist'
            ],
          },
          {
            key: "users",
            versions: ["v1"],
            current_version: "v1",
            enabled: true,
            desc: 'features.users',
            subfeatures: [],
            configs: {
              title: "menu.user.users",
              url: "settings/users"
            },
            roles: [
              'owner',
              'admin',
              'merchant-admin',
              'merchant-owner'
            ]
          },
          {
            key: 'merchant',
            versions: ['v1'],
            current_version: 'v1',
            enabled: true,
            desc: 'features.merchants',
            subfeatures: [],
            configs: {
              title: 'menu.merchants',
              url: 'settings/merchant',
            },
            roles: [
              'admin',
              'viewer',
              'owner',
              'finance-specialist',
              'merchant-admin',
              'merchant-viewer',
              'merchant-owner',
              'merchant-finance-specialist'
            ],
          },
          {
            key: "reports",
            versions: ["v1"],
            current_version: "v1",
            enabled: true,
            desc: 'features.reports',
            subfeatures: [],
            configs: {
              icon: "icon_settings",
              title: "menu.user.reports",
              url: "settings/reports"
            },
            roles: [
              'admin',
              'viewer',
              'owner',
              'finance-analyst',
              'finance-specialist',
              'merchant-finance-analyst',
              'merchant-viewer',
              'merchant-admin',
              'merchant-owner',
              'merchant-finance-analyst',
              'merchant-finance-specialist'
            ]
          },
          {
            key: "help",
            versions: ["v1"],
            current_version: "v1",
            enabled: true,
            desc: 'features.help',
            subfeatures: [],
            configs: {
              icon: "icon_settings",
              title: "menu.user.help",
              url: "settings/help"
            },
            roles: [
              'admin',
              'viewer',
              'owner',
              'finance-analyst',
              'finance-specialist',
              'merchant-finance-analyst',
              'merchant-viewer',
              'merchant-admin',
              'merchant-owner',
              'merchant-finance-analyst',
              'merchant-finance-specialist'
            ]
          },
          {
            key: "settings,letter",
            versions: ["v1"],
            current_version: "v1",
            enabled: false,
            can_add: true,
            desc: 'features.letter',
            subfeatures: [],
            configs: {
              icon: "icon_settings",
              title: "menu.user.letter",
              url: "settings/letter"
            },
            roles: [
              'admin'
            ]
          }
        ],
        configs: {
          icon: 'icon_settings',
          title: 'menu.settings',
          url: 'settings',
        },
        roles: [
          'admin',
          'viewer',
          'owner',
          'finance-analyst',
          'finance-specialist',
          'merchant-finance-analyst',
          'merchant-viewer',
          'merchant-admin',
          'merchant-owner',
          'merchant-finance-analyst',
          'merchant-finance-specialist'
        ],
      },
    ],

    tuna: [
      {
        key: 'partners',
        versions: ['v1'],
        current_version: 'v1',
        enabled: true,
        is_menu: true,
        desc: 'features.partners',
        subfeatures: [],
        configs: {
          icon: 'icon_merchants',
          title: 'menu.partners',
          url: 'partners',
        },
        roles: ['admin', 'viewer'],
      },
      {
        key: "financial-updates",
        versions: ["v1"],
        current_version: "v1",
        enabled: true,
        is_menu: true,
        desc: 'features.financialUpdates',
        subfeatures: [],
        configs: {
          icon: "icon_currency_exchange",
          title: "menu.financialUpdates",
          url: "financial-updates"
        },
        roles: ['admin', 'viewer']
      }
    ],
  },
  realmTuna: 'tuna'

};
